import React from 'react'
import { Card } from '@material-ui/core'
import StructureTabs from './StructureTabs/StructureTabs'
import AssignmentInfo from '../CommonContent/AssignmentInfo/AssignmentInfo'
import AssignmentHeader from './AssignmentHeader/AssignmentHeader'

const assignPageContent = ({
  inputChanged,
  assignmentData,
  frequencyOptions,
  responsibleOptions,
  submitButtonDisabled,
  submitButtonClicked,
  cancelButtonClicked,
  applyButtonClicked,
  addButtonClicked,
  pagePermission,
  assignmentInfo,
  assignmentTargetIds,
  fireAlert,
  assignSuccessList,
  responsibleSearchChanged,
  appraisalType,
  loadingQueue
}) => {
  return (
    <Card>
      <AssignmentHeader />
      <AssignmentInfo assignmentInfo={assignmentInfo} />
      <StructureTabs
        fireAlert={fireAlert}
        assignmentTargetIds={assignmentTargetIds}
        assignmentData={[...assignmentData]}
        assignSuccessList={assignSuccessList}
        inputChanged={inputChanged}
        frequencyOptions={frequencyOptions}
        responsibleSearchChanged={responsibleSearchChanged}
        responsibleOptions={responsibleOptions}
        addButtonClicked={addButtonClicked}
        applyButtonClicked={applyButtonClicked}
        actionDisabled={!pagePermission?.is_edit}
        submitButtonDisabled={submitButtonDisabled}
        submitButtonClicked={submitButtonClicked}
        cancelButtonClicked={cancelButtonClicked}
        appraisalType={appraisalType}
        loadingQueue={loadingQueue}
      />
    </Card>
  )
}

export default assignPageContent
